export default "<div class=\"well\" ng-transclude>\n</div>";